module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Leads.b6c60843.PNG";